/**
 * 特殊地址配置
 * 用于标识和显示特殊的地址（如 Canister、官方地址等）
 */

export interface SpecialAddressConfig {
	address: string;
	displayName: {
		zh: string;
		en: string;
	};
	tag?: {
		label: {
			zh: string;
			en: string;
		};
		variant: "default" | "canister" | "dev" | "official";
		className?: string;
	};
}

/**
 * 特殊地址列表
 * 在此添加需要特殊显示的地址配置
 */
export const SPECIAL_ADDRESSES: SpecialAddressConfig[] = [
	{
		address: "lxipt-3aaaa-aaaap-qqecq-cai",
		displayName: {
			zh: "奥丁宝符炉",
			en: "Odin Rune Furnace",
		},
		tag: {
			label: {
				zh: "Canister",
				en: "Canister",
			},
			variant: "canister",
			className: "bg-blue-500 text-white",
		},
	},
	{
		address: "r4sm7-wiaaa-aaaam-aeo4q-cai",
		displayName: {
			zh: "符文桥",
			en: "Rune Bridge",
		},
		tag: {
			label: {
				zh: "Canister",
				en: "Canister",
			},
			variant: "canister",
			className: "bg-blue-500 text-white",
		},
	},
	{
		address: "oefvx-fqaaa-aaaac-a7wwa-cai",
		displayName: {
			zh: "奥丁红包",
			en: "Odin Red Packet",
		},
		tag: {
			label: {
				zh: "Canister",
				en: "Canister",
			},
			variant: "canister",
			className: "bg-blue-500 text-white",
		},
	},
];

/**
 * 特殊地址映射（用于快速查询）
 */
const SPECIAL_ADDRESSES_MAP = new Map(
	SPECIAL_ADDRESSES.map((config) => [config.address, config]),
);

/**
 * 检查是否为特殊地址
 */
export function isSpecialAddress(address: string): boolean {
	return SPECIAL_ADDRESSES_MAP.has(address);
}

/**
 * 获取特殊地址配置
 */
export function getSpecialAddressConfig(
	address: string,
): SpecialAddressConfig | undefined {
	return SPECIAL_ADDRESSES_MAP.get(address);
}
